import React, { useState } from 'react';
// import logo from '../logo.svg';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const MENU = [
  {
    key: 'analytics',
    label: 'Analytics',
    icon: (
      <AnalyticsOutlinedIcon style={{ fontSize: 24 }} />
    ),
  },
  // {
  //   key: 'games',
  //   label: 'Games',
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" viewBox="0 0 24 24">
  //       <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2 14.5c0-3.287 0-4.931.908-6.038a4 4 0 0 1 .554-.554C4.57 7 6.212 7 9.5 7h5c3.288 0 4.931 0 6.038.908a4 4 0 0 1 .554.554C22 9.57 22 11.212 22 14.5s0 4.931-.908 6.038a4 4 0 0 1-.554.554C19.43 22 17.788 22 14.5 22h-5c-3.287 0-4.931 0-6.038-.908a4 4 0 0 1-.554-.554C2 19.43 2 17.788 2 14.5M12 7V5a1 1 0 0 1 1-1a1 1 0 0 0 1-1V2m-4 14l-1.5-1.5m0 0L7 13m1.5 1.5L7 16m1.5-1.5L10 13m7 2.5v-2" color="currentColor"></path>
  //     </svg>
  //   ),
  // },
  {
    key: 'settings',
    label: 'Settings',
    icon: (
      <SettingsOutlinedIcon style={{ fontSize: 24 }} />
    ),
  },
];

const Sidebar = ({ activeMenu, openTab }) => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <div className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="sidebar-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '24px 16px 16px 16px' }}>
        <IconButton
          onClick={() => setCollapsed(c => !c)}
          size="medium"
          sx={{
            background: '#f7fafc',
            border: '1.5px solid #e5e7eb',
            boxShadow: '0 1px 4px #e5e7eb33',
            width: 36,
            height: 36,
            p: 0,
            transition: 'background 0.18s, border 0.18s',
            '&:hover': {
              background: '#eaffd6',
              border: '1.5px solid #1db954',
            },
          }}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <nav className="sidebar-menu" style={{ marginTop: 0 }}>
        {MENU.map(item => (
          <div
            key={item.key}
            className={`sidebar-menu-item${activeMenu === item.key ? ' active' : ''}`}
            onClick={() => openTab(item.key)}
            title={item.label}
            style={activeMenu === item.key ? { background: '#d3ede2', color: '#1db954', fontWeight: 600 } : {}}
          >
            <span className="sidebar-icon" style={activeMenu === item.key ? { color: '#1db954' } : {}}>{item.icon}</span>
            {!collapsed && <span className="sidebar-label">{item.label}</span>}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar; 